<script setup>
// §8.4 StatusChip — label + shape + tinted fill. Six states (§3.5).
// TWO LOCKED RULES:
//   1. Never colour alone — always a label AND a shape (D6).
//   2. NEVER clickable. A chip is a label. Status chips are always tinted
//      fills; interactive is always a solid fill or an underlined link
//      (§3.5.4). This is what keeps the Unconfirmed blue (#24507A) from
//      colliding with the Counsel interactive blue (#2B5C8A).
// Day-level only — entries never carry a status chip (§8.4 TimeEntryRow).
import { computed } from 'vue'
import StatusShape from './StatusShape.vue'
import { STATUS } from './statusMeta.js'

const props = defineProps({
  state: { type: String, required: true },
  label: { type: String, default: null }, // override the default lifecycle label
})

const text = computed(() => props.label ?? STATUS[props.state]?.label ?? props.state)
</script>

<template>
  <span class="chip" :data-s="state">
    <StatusShape :state="state" />
    {{ text }}
  </span>
</template>

<style scoped>
/* cursor:default is deliberate — a chip is not interactive. */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-ui);
  font-size: var(--text-chip);
  font-weight: 600;
  padding: 3px 11px;
  border-radius: var(--r-pill);
  white-space: nowrap;
  cursor: default;
  background: var(--status-confirmed-fill);
  color: var(--status-confirmed-fg);
}
.chip[data-s='unconfirmed'] { background: var(--status-unconfirmed-fill); color: var(--status-unconfirmed-text); }
.chip[data-s='confirmed']   { background: var(--status-confirmed-fill);   color: var(--status-confirmed-text); }
.chip[data-s='pending']     { background: var(--status-pending-fill);     color: var(--status-pending-text); }
.chip[data-s='approved']    { background: var(--status-approved-fill);    color: var(--status-approved-text); }
.chip[data-s='rejected']    { background: var(--status-rejected-fill);    color: var(--status-rejected-text); }
.chip[data-s='notreq']      { background: var(--status-notreq-fill);      color: var(--status-notreq-text); border: 1px solid var(--status-notreq-border); }
</style>
